import { render, staticRenderFns } from "./AlfaSettingsModal.vue?vue&type=template&id=398895e8&"
import script from "./AlfaSettingsModal.vue?vue&type=script&lang=js&"
export * from "./AlfaSettingsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports